import { render, staticRenderFns } from "./ed-papers-write-object.vue?vue&type=template&id=1fd71d48&scoped=true&"
import script from "./ed-papers-write-object.ts?vue&type=script&lang=ts&"
export * from "./ed-papers-write-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-papers-write-object.scss?vue&type=style&index=0&id=1fd71d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd71d48",
  null
  
)

export default component.exports